import { css } from "@emotion/react";

export const root = css`
  width: 368px;
`;
